import {Typography} from '@sollapay/ui';
import {getCurrentYear, LEGAL_ROUTES} from '@sollapay/utils';
import {DebugModeButton} from '@sollapay/web-core';
import {useTranslation} from 'react-i18next';

import {config} from '@/app/app.config';
import {ReportBugButton} from '@/components';

import {FooterLink} from './FooterLink';

import type {FC} from 'react';

export const Footer: FC = () => {
  const {t} = useTranslation();

  return (
    <footer
      data-slot="app-footer"
      className="grid h-14 shrink-0 grid-cols-3 items-center gap-4 border-t border-border px-6 lg:px-10"
    >
      <Typography size="sm" color="secondary" className="justify-self-start">
        {t('footer.copyright', {year: getCurrentYear()})}
      </Typography>

      <nav data-slot="footer-links" className="flex items-center justify-self-center gap-2">
        <FooterLink href={LEGAL_ROUTES.termsOfUse} label={t('footer.termsOfUse')} />
        <Typography as="span" size="sm" className="text-fg-tertiary">
          ·
        </Typography>
        <FooterLink href={LEGAL_ROUTES.privacyPolicy} label={t('footer.privacyPolicy')} />
      </nav>

      <div className="flex items-center justify-self-end gap-2">
        {config.debug && (
          <DebugModeButton
            environment={config.environment}
            appVersion={config.appVersion}
            apiUrl={config.apiUrl}
          />
        )}
        <ReportBugButton showAttentionDot />
      </div>
    </footer>
  );
};
